import { useEffect, useState, useCallback } from "react";
import { Users, Check, X, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg } from "@/lib/api";

const FILTERS = [["pending", "In attesa"], ["approved", "Approvati"], ["rejected", "Rifiutati"]];
const BADGE = { pending: "text-[var(--draw)]", approved: "text-[var(--win)]", rejected: "text-[var(--loss)]" };

export default function SubscribersPanel({ base = "/subscribers", title = "Utenti del bot" }) {
  const [subs, setSubs] = useState([]);
  const [filter, setFilter] = useState("pending");
  const [busy, setBusy] = useState(null);

  const load = useCallback(() => http.get(base).then((r) => setSubs(r.data)), [base]);
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, [load]);

  const decide = async (s, decision) => {
    setBusy(s.chat_id);
    try {
      const r = await http.post(`${base}/${s.chat_id}/${decision}`);
      toast.success(`${s.name || s.chat_id} ${decision === "approve" ? "approvato" : "rifiutato"}${r.data.notified ? " · notificato su Telegram" : ""}`);
      load();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(null);
  };

  const count = (f) => subs.filter((s) => s.status === f).length;
  const shown = subs.filter((s) => s.status === filter);

  return (
    <div data-testid="subscribers-panel" className="panel p-6">
      <div className="flex items-center justify-between">
        <h3 className="font-display text-2xl font-bold uppercase flex items-center gap-2"><Users size={20} /> {title}</h3>
        <button data-testid="subscribers-refresh-btn" onClick={load} className="text-slate-400 hover:text-white transition-colors"><RefreshCw size={16} /></button>
      </div>
      <p className="text-sm text-slate-400 mt-1">Chi scrive /start al bot deve essere approvato qui prima di ricevere i pronostici.</p>
      <div className="flex gap-2 mt-4">
        {FILTERS.map(([f, l]) => (
          <button key={f} data-testid={`subscribers-filter-${f}`} onClick={() => setFilter(f)} className={`btn py-1.5 text-xs ${filter === f ? "btn-gold" : "btn-ghost"}`}>
            {l} <span data-testid={`subscribers-count-${f}`} className="font-mono">{count(f)}</span>
          </button>
        ))}
      </div>
      <ul data-testid="subscribers-list" className="mt-4 space-y-2 max-h-72 overflow-y-auto text-sm">
        {shown.length === 0 && <li className="text-slate-500 py-2">Nessun utente in questa lista.</li>}
        {shown.map((s) => (
          <li key={s.chat_id} data-testid={`subscriber-row-${s.chat_id}`} className="flex items-center justify-between gap-3 border-b border-slate-800/60 pb-2">
            <div className="min-w-0">
              <div className="truncate">{s.name || "—"} {s.username && <span className="text-slate-500">@{s.username}</span>}</div>
              <div className={`font-mono text-[11px] ${BADGE[s.status]}`}>{s.status.toUpperCase()} · ID {s.chat_id}{s.active === false ? " · notifiche off" : ""}</div>
            </div>
            <div className="flex gap-2 shrink-0">
              {s.status !== "approved" && (
                <button data-testid={`approve-subscriber-${s.chat_id}`} disabled={busy === s.chat_id} onClick={() => decide(s, "approve")} className="btn py-1.5 bg-[var(--win)] text-slate-950"><Check size={14} /> Approva</button>
              )}
              {s.status !== "rejected" && (
                <button data-testid={`reject-subscriber-${s.chat_id}`} disabled={busy === s.chat_id} onClick={() => decide(s, "reject")} className="btn btn-ghost py-1.5 text-[var(--loss)]"><X size={14} /> {s.status === "approved" ? "Revoca" : "Rifiuta"}</button>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
